import { useContext } from 'react'
import { useTranslation } from 'react-i18next'

import { CalendarBlankIcon } from '@phosphor-icons/react'

import { Alert, Button, ButtonWithSpinner, CardTitle, ComboBox, Drawer, Loading, Text } from '@reveni-io/reveni-ui'

import AppContext from '@/common/context/app.context'

import { getFormattedAndSortedDates } from './helpers'
import * as Styles from './styles'

const SchedulePickupDrawer = ({
  show,
  onClose,
  onSchedule,
  loading,
  datesAndTimeRangesForSchedulePickup,
  fetchingDatesAndTimeRangesForSchedulePickup,
  selectedPickupDate,
  setSelectedPickupDate,
  selectedTimeRange,
  setSelectedTimeRange,
}) => {
  const { t, i18n } = useTranslation()
  const { info } = useContext(AppContext)

  const getTimeRangeLabel = tr => {
    if (tr) {
      return t('De {{tr.start}} a {{tr.end}}', { tr })
    }
  }

  return (
    <Drawer show={show} onClose={onClose} options={{ showHeaderActions: false }}>
      <CardTitle Icon={CalendarBlankIcon}>{t('Programar nueva recogida')}</CardTitle>
      <Loading show={fetchingDatesAndTimeRangesForSchedulePickup}>
        <Styles.Container>
          <Text type="bodyMRegular">
            {t(
              'Por favor, confirma que quieres programar una nueva recogida en la dirección escogida por el cliente. Solo se puede programar una nueva recogida cada 24h.'
            )}
          </Text>
          {datesAndTimeRangesForSchedulePickup?.pickup_dates?.length > 1 ? (
            <div>
              <ComboBox
                menuItems={getFormattedAndSortedDates(
                  datesAndTimeRangesForSchedulePickup?.pickup_dates,
                  i18n.language,
                  info?.selectedStore?.timezone
                )}
                label={t('Día de recogida')}
                fullWidth
                value={selectedPickupDate}
                handleChange={e => setSelectedPickupDate(e.target.value)}
              />
              {datesAndTimeRangesForSchedulePickup?.time_ranges?.length > 0 && (
                <ComboBox
                  label={t('Franja horaria')}
                  fullWidth
                  menuItems={datesAndTimeRangesForSchedulePickup?.time_ranges?.map(tr => ({
                    label: getTimeRangeLabel(tr),
                    value: tr.id,
                  }))}
                  value={selectedTimeRange}
                  handleChange={e => setSelectedTimeRange(e.target.value)}
                />
              )}
            </div>
          ) : (
            <Styles.NextRequestDateContainer>
              <CalendarBlankIcon size={24} />
              <Text type="bodyMBold">
                {
                  getFormattedAndSortedDates(
                    datesAndTimeRangesForSchedulePickup?.pickup_dates,
                    i18n.language,
                    info?.selectedStore?.timezone
                  )?.[0]?.label
                }
              </Text>
            </Styles.NextRequestDateContainer>
          )}
          <Alert type="warning">{t('Esta acción no se podrá deshacer más adelante. ¿Quieres continuar?')}</Alert>
          <Styles.ActionsContainer>
            <Button fullWidth variant="outlined" onClick={onClose}>
              {t('Cancelar')}
            </Button>
            <ButtonWithSpinner
              fullWidth
              onClick={onSchedule}
              loading={loading}
              disabled={loading}
              defaultLabel={t('Programar nueva recogida')}
              loadingLabel={t('Programar nueva recogida')}
            />
          </Styles.ActionsContainer>
        </Styles.Container>
      </Loading>
    </Drawer>
  )
}

export default SchedulePickupDrawer
